import React, { useState } from 'react';
import '../styling/patientInfoForm.css';

const PatientInfoForm = ({ onSubmit }) => {
  const [patientInfo, setPatientInfo] = useState({
    patientID: '',
    phoneNumber: ''
  });

  const handleChange = (e) => {
    setPatientInfo(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!patientInfo.patientID || !patientInfo.phoneNumber) {
      alert('Please fill in all fields');
      return;
    }
    onSubmit(patientInfo);
  };

  return (
    <div className="patient-info-form">
      <h2>Patient Information</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="patientID">Patient ID:</label>
          <input
            type="text"
            id="patientID"
            name="patientID"
            value={patientInfo.patientID}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="phoneNumber">Phone Number:</label>
          <input
            type="text"
            id="phoneNumber"
            name="phoneNumber"
            value={patientInfo.phoneNumber}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">Continue to Form</button>
      </form>
    </div>
  );
};

export default PatientInfoForm;